import { Suppliers } from './pages/supplierList';
import { SuppliersForm } from './pages/supplierForm';

export const SupplierRoutes = [
  {
    path: '/fornecedores',
    exact: true,
    component: () => <Suppliers />,
  },
  {
    path: '/fornecedores/novo',
    exact: true,
    component: () => <SuppliersForm />,
  },
  {
    path: '/fornecedores/edit/:id',
    exact: true,
    component: () => <SuppliersForm />,
  },
];
